export default __webpack_public_path__ + "static/media/elevate-bbl-3.3bbd8341.png";